const upsellBundleSelectors = document.querySelector("div.upsell_enabled");

if (upsellBundleSelectors) {
  document.addEventListener("DOMContentLoaded", () => {
    const upsellBundleSelectors = document.querySelector("div.upsell_enabled"),
      productFormATCBtn = document.querySelector(
        "div.upsell_enabled button.add-to-cart.upsell-atc"
      ),
      upsellContainer = document.querySelector(".upsell-popup"),
      upsellTotal = document.querySelector(".upsell-total");
    // console.log("upsellContainer", upsellContainer);
    // console.log("productFormATCBtn", productFormATCBtn);
    // console.log("upsellBundleSelectors", upsellBundleSelectors);
    // console.log(
    //   "upsell Pop container",
    //   document.querySelector(".upsell-popup")
    // );

    const bundleSelectors = document.querySelectorAll(
      '[data-element-type="bundle-selector"]'
    );
    const addToCartFormInput = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );

    const payFullPriceElements = document.querySelectorAll(
      '[data-element-type="pay-full-price"]'
    );
    const payPartPriceElements = document.querySelectorAll(
      '[data-element-type="pay-part-price"]'
    );
    const checkoutButton = document.querySelector("#checkout-button");

    const updatePrices = (bundle) => {
      const selectedPayPartPriceValue = bundle.querySelector(
        'input[name="payPartPrice"]'
      ).value;
      const selectedPayFullPriceValue = bundle.querySelector(
        'input[name="payFullPrice"]'
      ).value;

      payPartPriceElements.forEach((payPartPriceElement) => {
        payPartPriceElement.textContent = selectedPayPartPriceValue;
      });

      payFullPriceElements.forEach((payFullPriceElement) => {
        payFullPriceElement.textContent = selectedPayFullPriceValue;
      });
    };

    const upsellAddItemToCart = async (event) => {
      updateFormInput();
      console.log("addToCartFormInput", addToCartFormInput);
      event.preventDefault();
      event.stopPropagation();
      console.log(event.target);
      console.log("variantId", addToCartFormInput.value);

      try {
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("cart cleared");
      } catch (error) {
        console.error("Error clearing cart:", error);
      }

      let formData = {
        items: [
          {
            id: addToCartFormInput.value,
          },
        ],
        sections: "cart-drawer",
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        console.log("cart added", data);
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.getSectionsToRender();
          cartDrawer.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }

      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        upsellTotal.textContent = data.total_price / 100;
        console.log("cart data", data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    bundleSelectors.forEach((bundle, index, array) => {
      let bundleInput = bundle.querySelector('input[type="radio"]');
      // console.log(bundleInput.getAttribute("value"));
      // console.log("productFormATCBtn", productFormATCBtn);
      const inputRadio = bundle.querySelector(
        '[data-element-type="radio-button"]'
      );
      const selectedArrow = bundle.querySelector(
        '[data-element-type="selected-arrow"]'
      );

      const updateFormInput = () => {
        if (bundleInput.checked) {
          const variantId = bundleInput.getAttribute("value");
          const cartDrawer = document.querySelector("cart-drawer");
          if (addToCartFormInput) {
            addToCartFormInput.setAttribute("value", variantId);
          }
          if (checkoutButton) {
            checkoutButton.href = `/cart/${variantId}:1`;
          }
        }
      };

      bundleInput.addEventListener("click", () => {
        updateFormInput();

        const allInputRadios = document.querySelectorAll(
          '[data-element-type="radio-button"]'
        );

        const allSelectedArrows = document.querySelectorAll(
          '[data-element-type="selected-arrow"]'
        );

        allInputRadios.forEach((radio) => {
          radio.classList.add("hidden");
        });

        inputRadio.classList.remove("hidden");

        if (allSelectedArrows) {
          allSelectedArrows.forEach((arrow) => {
            arrow.classList.add("hidden");
          });

          if (selectedArrow) {
            selectedArrow.classList.remove("hidden");
          }
        }

        updatePrices(bundle);
      });

      const upsellAddItemToCart = async (event) => {
        // console.log("addToCartFormInput", addToCartFormInput);
        event.preventDefault();

        updateFormInput();
        // console.log(event.target);
        // console.log("variantId", addToCartFormInput.value);

        try {
          await fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });
          // console.log("cart cleared");
        } catch (error) {
          console.error("Error clearing cart:", error);
        }

        let formData = {
          items: [
            {
              id: addToCartFormInput.value,
              quantity: 1,
            },
          ],
          sections: "cart-drawer",
        };

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });

          const data = await response.json();
          // console.log("cart added", data);
          // console.log("item added id", data.items[0].id);
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.getSectionsToRender();
            cartDrawer.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
            return;
          }
        } catch (error) {
          console.error("Error:", error);
        }

        try {
          const response = await fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const data = await response.json();
          upsellTotal.textContent = data.total_price / 100;
          // console.log("cart data", data);
        } catch (error) {
          console.error("Error:", error);
        }
      };

      // Check if all elements in the array are present
      if (bundleInput) {
        bundleInput.addEventListener("click", upsellAddItemToCart);
      }

      if (bundleInput.checked) {
        inputRadio.classList.remove("hidden");
        updatePrices(bundle); // Update prices on page load based on the checked bundle
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      } else {
        inputRadio.classList.add("hidden");
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      }

      if (index === 0) {
        bundleInput.checked = true;
        // bundleInput.dispatchEvent(new Event("click"));
      }
    });

    //ADD TO CART EVENT LISTENER
    const updateFormInput = () => {
      if (bundleInput.checked) {
        const variantId = bundleInput.getAttribute("value");
        const cartDrawer = document.querySelector("cart-drawer");
        if (addToCartFormInput) {
          addToCartFormInput.setAttribute("value", variantId);
        }
        if (checkoutButton) {
          checkoutButton.href = `/cart/${variantId}:1`;
        }
      }
    };

    // console.log(productFormATCBtn);
    productFormATCBtn.addEventListener("click", async (event) => {
      event.preventDefault();
      // console.log("clicked");
      try {
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
        // console.log("cart cleared");
      } catch (error) {
        console.error("Error clearing cart:", error);
      }

      let formData = {
        items: [
          {
            id: addToCartFormInput.value,
            // quantity: 1,
          },
        ],
        sections: "cart-drawer",
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        // console.log("cart added", data);
        // console.log("item added id", data.items[0].id);
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.getSectionsToRender();
          cartDrawer.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }

      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        upsellTotal.textContent = data.total_price / 100;
        // console.log("cart data", data);
      } catch (error) {
        console.error("Error:", error);
      }
    });
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    const bundleSelectors = document.querySelectorAll(
      '[data-element-type="bundle-selector"]'
    );
    const addToCartFormInput = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );

    const payFullPriceElements = document.querySelectorAll(
      '[data-element-type="pay-full-price"]'
    );
    const payPartPriceElements = document.querySelectorAll(
      '[data-element-type="pay-part-price"]'
    );
    const checkoutButton = document.querySelector("#checkout-button");

    const updatePrices = (bundle) => {
      const selectedPayPartPriceValue = bundle.querySelector(
        'input[name="payPartPrice"]'
      ).value;
      const selectedPayFullPriceValue = bundle.querySelector(
        'input[name="payFullPrice"]'
      ).value;

      payPartPriceElements.forEach((payPartPriceElement) => {
        payPartPriceElement.textContent = selectedPayPartPriceValue;
      });

      payFullPriceElements.forEach((payFullPriceElement) => {
        payFullPriceElement.textContent = selectedPayFullPriceValue;
      });
    };

    bundleSelectors.forEach((bundle, index, array) => {
      const bundleInput = bundle.querySelector('input[type="radio"]');
      const inputRadio = bundle.querySelector(
        '[data-element-type="radio-button"]'
      );
      const selectedArrow = bundle.querySelector(
        '[data-element-type="selected-arrow"]'
      );

      const updateFormInput = () => {
        if (bundleInput.checked) {
          const variantId = bundleInput.getAttribute("value");
          if (addToCartFormInput) {
            const formType = addToCartFormInput.getAttribute('form-type');
            if (formType !== 'cart-upsell') {
              addToCartFormInput.setAttribute("value", variantId);
            }
          }
          if (checkoutButton) {
            checkoutButton.href = `/cart/${variantId}:1`;
          }
        }
      };

      bundleInput.addEventListener("click", () => {
        updateFormInput();

        const allInputRadios = document.querySelectorAll(
          '[data-element-type="radio-button"]'
        );

        const allSelectedArrows = document.querySelectorAll(
          '[data-element-type="selected-arrow"]'
        );

        allInputRadios.forEach((radio) => {
          radio.classList.add("hidden");
        });

        inputRadio.classList.remove("hidden");

        if (allSelectedArrows) {
          allSelectedArrows.forEach((arrow) => {
            arrow.classList.add("hidden");
          });

          if (selectedArrow) {
            selectedArrow.classList.remove("hidden");
          }
        }

        updatePrices(bundle);
      });

      updateFormInput();

      if (bundleInput.checked) {
        inputRadio.classList.remove("hidden");
        updatePrices(bundle); // Update prices on page load based on the checked bundle
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      } else {
        inputRadio.classList.add("hidden");
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      }

      // If this is the first bundle, automatically check its radio button
      // if (index === 0) {
      //   bundleInput.checked = true;
      //   bundleInput.dispatchEvent(new Event("click"));
      // }
    });
    
    for (const bundleSelector of bundleSelectors) {
      bundleSelector.onclick = function (event) {
        const itemCount = bundleSelector.getAttribute('data-item-count');

        for (const oneElement of bundleSelectors) {
          oneElement.classList.remove('active');
        }
        bundleSelector.classList.add('active');

        const customTitle = bundleSelector.getAttribute('data-variant-title');
        if (customTitle) {
          const customTitleElement = document.querySelector('.product-section-dynamic-title');
          if (customTitleElement) {
            customTitleElement.textContent = customTitle;
          }
        }

        // Update variant image dynamatically
        if (itemCount) {
          const imageToReplace = document.querySelector(`.hidden-variant-advert-image[data-count="${itemCount}"]`);
          const parentElement = document.querySelector('#my-keen-slider .keen-slider__slide:first-child > div');

          if (imageToReplace && parentElement) {
            parentElement.innerHTML = '';
            parentElement.appendChild(imageToReplace.cloneNode(true));
          }
        }
      };
    }
  });
}

// document.addEventListener("DOMContentLoaded", () => {
//   const upsellBundleSelectors = document.querySelector("div.upsell_enabled"),
//     productFormATCBtn = document.querySelector(
//       "div.upsell_enabled button.add-to-cart"
//     ),
//     upsellContainer = document.querySelector(".upsell-popup"),
//     upsellTotal = document.querySelector(".upsell-total");
//   console.log("upsellContainer", upsellContainer);
//   console.log("productFormATCBtn", productFormATCBtn);
//   console.log("upsellBundleSelectors", upsellBundleSelectors);
//   console.log("upsell Pop container", document.querySelector(".upsell-popup"));

//   const bundleSelectors = document.querySelectorAll(
//     '[data-element-type="bundle-selector"]'
//   );
//   const addToCartFormInput = document.querySelector(
//     'form[data-type="add-to-cart-form"] input[name="id"]'
//   );

//   const payFullPriceElements = document.querySelectorAll(
//     '[data-element-type="pay-full-price"]'
//   );
//   const payPartPriceElements = document.querySelectorAll(
//     '[data-element-type="pay-part-price"]'
//   );
//   const checkoutButton = document.querySelector("#checkout-button");

//   let bundleInput;

//   const updatePrices = (bundle) => {
//     const selectedPayPartPriceValue = bundle.querySelector(
//       'input[name="payPartPrice"]'
//     ).value;
//     const selectedPayFullPriceValue = bundle.querySelector(
//       'input[name="payFullPrice"]'
//     ).value;

//     payPartPriceElements.forEach((payPartPriceElement) => {
//       payPartPriceElement.textContent = selectedPayPartPriceValue;
//     });

//     payFullPriceElements.forEach((payFullPriceElement) => {
//       payFullPriceElement.textContent = selectedPayFullPriceValue;
//     });
//   };

//   const updateFormInput = () => {
//     if (bundleInput && bundleInput.checked) {
//       const variantId = bundleInput.getAttribute("value");
//       const cartDrawer = document.querySelector("cart-drawer");
//       if (addToCartFormInput) {
//         addToCartFormInput.setAttribute("value", variantId);
//       }
//       if (checkoutButton) {
//         checkoutButton.href = `/cart/${variantId}:1`;
//       }
//     }
//   };

//   const addToCart = async () => {
//     updateFormInput();
//     console.log("addToCartFormInput", addToCartFormInput);

//     try {
//       await fetch("/cart/clear.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       console.log("cart cleared");
//     } catch (error) {
//       console.error("Error clearing cart:", error);
//     }

//     let formData = {
//       items: [
//         {
//           id: addToCartFormInput.value,
//           quantity: 1,
//         },
//       ],
//       sections: "cart-drawer",
//     };

//     try {
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();
//       console.log("cart added", data);
//       console.log("item added id", data.items[0].id);
//       const cartDrawer = document.querySelector("cart-drawer");
//       if (cartDrawer) {
//         cartDrawer.getSectionsToRender();
//         cartDrawer.renderContents(data);
//       } else {
//         window.location = window.routes.cart_url;
//         return;
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }

//     try {
//       const response = await fetch("/cart.js", {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       const data = await response.json();
//       upsellTotal.textContent = data.total_price / 100;
//       console.log("cart data", data);
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   bundleSelectors.forEach((bundle, index) => {
//     bundleInput = bundle.querySelector('input[type="radio"]');
//     const inputRadio = bundle.querySelector(
//       '[data-element-type="radio-button"]'
//     );
//     const selectedArrow = bundle.querySelector(
//       '[data-element-type="selected-arrow"]'
//     );

//     bundleInput.addEventListener("click", () => {
//       updateFormInput();

//       const allInputRadios = document.querySelectorAll(
//         '[data-element-type="radio-button"]'
//       );

//       const allSelectedArrows = document.querySelectorAll(
//         '[data-element-type="selected-arrow"]'
//       );

//       allInputRadios.forEach((radio) => {
//         radio.classList.add("hidden");
//       });

//       inputRadio.classList.remove("hidden");

//       if (allSelectedArrows) {
//         allSelectedArrows.forEach((arrow) => {
//           arrow.classList.add("hidden");
//         });

//         if (selectedArrow) {
//           selectedArrow.classList.remove("hidden");
//         }
//       }

//       updatePrices(bundle);
//       addToCart(); // Call the shared addToCart function
//     });

//     if (bundleInput.checked) {
//       inputRadio.classList.remove("hidden");
//       updatePrices(bundle);
//       if (selectedArrow) {
//         selectedArrow.classList.remove("hidden");
//       }
//     } else {
//       inputRadio.classList.add("hidden");
//       if (selectedArrow) {
//         selectedArrow.classList.remove("hidden");
//       }
//     }

//     if (index === 0) {
//       bundleInput.checked = true;
//     }
//   });

//   // ADD TO CART EVENT LISTENER for productFormATCBtn
//   if (productFormATCBtn) {
//     productFormATCBtn.addEventListener("click", addToCart);
//   }
// });

(() => {
  const UK_PAGE_PATH = "/pages/epil-pro-3-uk";
  const UK_SECTION_ID =
    "template--22451727859960__f051c91f-e136-4892-b2ff-886bed068fe3";
  const UK_DEFAULT_VARIANT_ID = "48113297424632";

  const isUkSkuPage = () => {
    const path = window.location.pathname.replace(/\/$/, "");
    return path === UK_PAGE_PATH;
  };

  const isProductMissing = () => {
    const productRoot = document.getElementById("products");
    return (
      productRoot &&
      (!productRoot.getAttribute("product-id") ||
        !productRoot.getAttribute("variant-id"))
    );
  };

  const updateBundlePrices = (bundle) => {
    const payPartPrice = bundle.querySelector('input[name="payPartPrice"]');
    const payFullPrice = bundle.querySelector('input[name="payFullPrice"]');

    if (!payPartPrice || !payFullPrice) return;

    document
      .querySelectorAll('[data-element-type="pay-part-price"]')
      .forEach((element) => {
        element.textContent = payPartPrice.value;
      });

    document
      .querySelectorAll('[data-element-type="pay-full-price"]')
      .forEach((element) => {
        element.textContent = payFullPrice.value;
      });
  };

  const updateProductFormVariant = (variantId) => {
    const input = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );
    const checkoutButton = document.querySelector("#checkout-button");

    if (input && input.getAttribute("form-type") !== "cart-upsell") {
      input.value = variantId;
      input.setAttribute("value", variantId);
      input.disabled = false;
    }

    if (checkoutButton) {
      checkoutButton.href = `/cart/${variantId}:1`;
    }
  };

  const bindUkBundleSelectors = () => {
    const bundles = Array.from(
      document.querySelectorAll('[data-element-type="bundle-selector"]')
    );
    if (!bundles.length) {
      updateProductFormVariant(UK_DEFAULT_VARIANT_ID);
      return;
    }

    const selectBundle = (bundle) => {
      const input = bundle.querySelector('input[type="radio"]');
      const variantId = input?.value;
      if (!variantId) return;

      bundles.forEach((item) => {
        item.classList.toggle("active", item === bundle);
        item
          .querySelector('[data-element-type="radio-button"]')
          ?.classList.add("hidden");
        item
          .querySelector('[data-element-type="selected-arrow"]')
          ?.classList.add("hidden");
      });

      input.checked = true;
      bundle
        .querySelector('[data-element-type="radio-button"]')
        ?.classList.remove("hidden");
      bundle
        .querySelector('[data-element-type="selected-arrow"]')
        ?.classList.remove("hidden");

      updateProductFormVariant(variantId);
      updateBundlePrices(bundle);

      const customTitle = bundle.getAttribute("data-variant-title");
      const titleElement = document.querySelector(
        ".product-section-dynamic-title"
      );
      if (customTitle && titleElement) {
        titleElement.textContent = customTitle;
      }
    };

    bundles.forEach((bundle) => {
      if (bundle.dataset.ukSkuFixBound === "true") return;
      bundle.dataset.ukSkuFixBound = "true";
      bundle.addEventListener("click", () => selectBundle(bundle));
    });

    selectBundle(
      bundles.find((bundle) => bundle.querySelector("input:checked")) ||
        bundles[0]
    );
  };

  const bindUkPaymentOptions = () => {
    const payNow = document.querySelector('[data-payment-option="pay-now"]');
    const payLater = document.querySelector('[data-payment-option="pay-later"]');
    const shopPayButton = document.querySelector("#shoppay-checkout");
    if (!payNow || !payLater) return;

    const setActive = (mode) => {
      const payNowRadio = payNow.querySelector("[data-option-radio]");
      const payLaterRadio = payLater.querySelector("[data-option-radio]");
      const isLater = mode === "later";

      payNowRadio?.classList.toggle("border-[6px]", !isLater);
      payNowRadio?.classList.toggle("border", isLater);
      payLaterRadio?.classList.toggle("border-[6px]", isLater);
      payLaterRadio?.classList.toggle("border", !isLater);
      shopPayButton?.classList.toggle("hidden", !isLater);
      payNow.classList.toggle("active", !isLater);
      payLater.classList.toggle("active", isLater);
    };

    if (payNow.dataset.ukSkuFixBound !== "true") {
      payNow.dataset.ukSkuFixBound = "true";
      payNow.addEventListener("click", () => setActive("now"));
    }

    if (payLater.dataset.ukSkuFixBound !== "true") {
      payLater.dataset.ukSkuFixBound = "true";
      payLater.addEventListener("click", () => setActive("later"));
    }

    setActive("now");
  };

  const repairUkSkuSection = async () => {
    if (!isUkSkuPage() || !isProductMissing() || window.__pluxyUkSkuFix) return;
    window.__pluxyUkSkuFix = true;

    const holder = document.getElementById(`shopify-section-${UK_SECTION_ID}`);
    if (!holder) return;

    const sectionUrl = `${UK_PAGE_PATH}?view=epil-pro-3-uk-fixed&section_id=${UK_SECTION_ID}&sku_fix=${Date.now()}`;

    try {
      const response = await fetch(sectionUrl, {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const html = await response.text();

      if (!response.ok || !html.includes(UK_DEFAULT_VARIANT_ID)) {
        throw new Error("UK product section did not include the expected SKU");
      }

      holder.innerHTML = html;
    } catch (error) {
      console.error("Pluxy UK SKU repair failed", error);
    } finally {
      bindUkBundleSelectors();
      bindUkPaymentOptions();
      updateProductFormVariant(UK_DEFAULT_VARIANT_ID);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", repairUkSkuSection);
  } else {
    repairUkSkuSection();
  }
})();
